<ion-input
  [label]="config.label"
  labelPlacement="floating"
  [placeholder]="config.placeholder"
  class="input-default {{ config.inputClass }}"
  [type]="config.inputType"
  [mode]="config.inputMode"
  [max]="config.mask"
  [maxlength]="config.maxLength"
  [value]="value"
  (input)="handleChange($event)"
></ion-input>
